import {
	openInCurrentStack,
	openNewBottomSheet,
	openNewFullscreenPage,
	openNewFullscreenSheet,
	v2,
	close as mbcClose,
	closeStack as mbcCloseStack,
	openInBrowser,
	getInitialState,
	onClosed,
	isNative,
	openPdf,
} from "@sparebank1/mobilbank-communication";

type TopBarTheme = "DEFAULT" | "SUBTLE" | "ACCENT";

interface OpenStackOptions {
	authenticationUpgradeRequired?: boolean;
	hideCloseButton?: boolean;
	hideNavigationBar?: boolean;
	hideTopBar?: boolean;
	initialState?: object;
	topBarTheme?: TopBarTheme;
}

export type StackType = "INTERNAL" | "EXTERNAL" | "SHEET" | "FULLSCREEN";

function open(url: string, topBarTitle: string, type: StackType = "INTERNAL", options?: OpenStackOptions) {
	switch (type) {
		case "INTERNAL":
			return openInCurrentStack(url, topBarTitle, options);
		case "EXTERNAL":
			return openNewFullscreenSheet(url, topBarTitle, options);
		case "SHEET":
			return openNewBottomSheet(url, topBarTitle, options);
		case "FULLSCREEN":
			return openNewFullscreenPage(url, topBarTitle, options);
	}
}

function close(closeStack?: boolean) {
	if (closeStack) mbcCloseStack();
	else mbcClose();
}

const openExternalWebTab = v2.openExternalWebTab;

const mbc = {
	isNative,
	getInitialState,
	open,
	openExternalWebTab,
	openInBrowser,
	openPdf,
	close,
	onClosed,
};
export default mbc;
